import React from 'react';
import { Box, Grid } from '@mui/material';
import { Body1, H1 } from '../../../components/typography';
import { PrimaryButton } from '../../../components/buttons';
import { TotalCountBadge } from '../../../components/badges';
import { useTranslation } from 'react-i18next';

interface Props {
    setIsOpen: (value: boolean) => void,
    rowCount: number
}

const Header:React.FC<Props> = ({
  setIsOpen,
  rowCount
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid size={8}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <H1>{t('Reservations')}</H1>
            <TotalCountBadge count={rowCount} />
          </Box>
        </Grid>
        <Grid size={4}>
          <Body1 align='right'>
            <PrimaryButton onClick={() => setIsOpen(true)}>{t('Create')}</PrimaryButton>
          </Body1>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
